import React from "react";
import { FileText, Music2, Video, X} from "lucide-react";

function ReplyPreview({ replyTo, conversation, onCancel, getReplyPreview}) {
  if (!replyTo) {
    return null;
  }

  return (
  <div className="mb-2.5 overflow-hidden rounded-xl border border-[#d8eaf4] bg-white shadow-[0_2px_8px_rgba(15,91,138,0.06)]">
    <div className="flex items-stretch">
      {/* Active indicator */}
      <div className="w-[3px] shrink-0 bg-[#147db5]" />

      <div className="flex min-w-0 flex-1 items-center gap-3 bg-[#f8fcfe] px-3 py-2.5">
        {/* Reply content */}
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold text-[#147db5]">
            {replyTo.direction === "Outgoing"
              ? "You"
              : conversation?.contact?.name || "Contact"}
          </p>

          <p className="mt-0.5 truncate text-[11px] leading-5 text-gray-500">
            {getReplyPreview(replyTo)}
          </p>
        </div>

        {/* Cancel */}
        <button
          type="button"
          onClick={onCancel}
          title="Cancel reply"
          className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-gray-400 transition-all duration-200 hover:bg-white hover:text-[#147db5] hover:shadow-sm"
        >
          <X size={15} strokeWidth={1.8}/>
        </button>
      </div>
    </div>
  </div>
);
}




function FilePreview({file,onRemove}) {
  if (!file) {
    return null;
  }

  const isImage = file.type.startsWith("image/");
  const isVideo = file.type.startsWith("video/");
  const isAudio = file.type.startsWith("audio/");

  return (
    <div className="mb-2.5 overflow-hidden rounded-xl border border-[#dfe4e7] bg-white p-3 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex min-w-0 items-center gap-3">
          {isImage ? (
            <img
              src={URL.createObjectURL(file)}
              alt=""
              className="h-16 w-16 shrink-0 rounded-lg object-cover"
            />
          ) : isVideo ? (
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg bg-[#eef4ff] text-[#4b78d1]">
              <Video size={27} />
            </div>
          ) : isAudio ? (
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg bg-[#fff4e8] text-[#e58a25]">
              <Music2 size={27} />
            </div>
          ) : (
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg bg-[#f0f2f5] text-[#54656f]">
              <FileText size={28} />
            </div>
          )}

          <div className="min-w-0">
            <p className="max-w-xs truncate text-sm font-medium text-[#3b4a54]">
              {file.name}
            </p>

            <p className="mt-1 text-xs text-[#8696a0]">
              {(file.size / 1024 / 1024).toFixed(2)} MB
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onRemove}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[#8696a0] transition hover:bg-[#f0f2f5] hover:text-[#54656f]"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}

export { FilePreview, ReplyPreview };
